/* global moment Validation flatpickr Handlebars */
HandlebarsIntl.registerWith(Handlebars);
const intlData = {
	locales: 'nl-NL',
	formats: {
		time: {
			hhmm: {
				hour: 'numeric',
				minute: 'numeric',
			},
		},
	},
};

class API {
	constructor() {
		this.apiBase = '/v1/api/';
		this.filterInitialized = false;
		this.limit = 9;
		this.offset = 0;
		this.page = 0;
		this.observer = new IntersectionObserver(this.lazyLoadItems);
		this.observationTarget = document.querySelector('.lazyload-js');
		this.lazyLoadTimeout = '';
		this.urlParams = this.getUrlParameters();
		this.isSearchPage = false;
		this.filtersInitializedCallback = undefined;

		if (this.urlParams.page !== undefined) {
			this.page = parseInt(this.urlParams.page, 10) - 1;
		}

		const type = document.querySelector('.object-types-js');
		if (type) {
			this.type = type.getAttribute('data-type').split(',');
		} else {
			this.type = [];
		}
	}
	encodeData(data) {
		let getParams;
		if (Object.keys(data).length !== 0 && data.constructor === Object) {
			getParams = '?';
			getParams += Object.keys(data).map(key => [key, data[key]].map(encodeURIComponent).join('=')).join('&');
			return getParams;
		}
		return '';
	}
	getCookie(name) {
		if (!document.cookie) {
			return null;
		}

		const xsrfCookies = document.cookie.split(';')
		.map(c => c.trim())
		.filter(c => c.startsWith(`${name}=`));

		if (xsrfCookies.length === 0) {
			return null;
		}
		return decodeURIComponent(xsrfCookies[0].split('=')[1]);
	}
	getUrlParameters(url) {
		// get query string from url (optional) or window
		let queryString = url ? url.split('?')[1] : window.location.search.slice(1);
		// we'll store the parameters here
		const obj = {};

		// if query string exists
		if (queryString) {
			// stuff after # is not part of query string, so get rid of it
			queryString = queryString.split('#')[0];

			// split our query string into its component parts
			const arr = queryString.split('&');

			arr.forEach((param) => {
				// separate the keys and the values
				const a = param.split('=');
				// in case params look like: list[]=thing1&list[]=thing2
				let paramNum;
				let paramName = a[0].replace(/\[\d*\]/, (v) => {
					paramNum = v.slice(1, -1);
					return '';
				});

				// set parameter value (use 'true' if empty)
				let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

				// (optional) keep case consistent
				paramName = paramName.toLowerCase();
				// paramValue = paramValue.toLowerCase();

				// if parameter name already exists
				if (obj[paramName]) {
					// convert value to array (if still string)
					if (typeof obj[paramName] === 'string') {
						obj[paramName] = [obj[paramName]];
					}
					// if no array index number specified...
					if (typeof paramNum === 'undefined') {
						// put the value on the end of the array
						obj[paramName].push(paramValue);
					} else {
						// if array index number specified...
						// put the value at that index number
						obj[paramName][paramNum] = paramValue;
					}
				} else {
					// if param name doesn't exist yet, set it
					obj[paramName] = paramValue;
				}
			});
		}
		return obj;
	}
	doAjaxGet(url, params, callback) {
		const payload = {
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				Cache: 'no-cache',
				'X-CSRFToken': this.getCookie('csrftoken'),
			},
			credentials: 'same-origin',
		};
		fetch(this.apiBase + url + this.encodeData(params), payload)
			.then((response) => {
				if (response.status !== 200) {
					console.error(`Looks like there was a problem. Status Code: ${response.status}`);
					return null;
				}
				response.json().then((data) => {
					if (typeof callback === 'function') {
						callback(data);
					}
				});
				return null;
			}).catch((error) => {
				console.error(`There has been a problem with your fetch operation: ${error.message}`);
			});
	}
	doAjaxPost(url, params, callback) {
		const payload = {
			method: 'POST',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				Cache: 'no-cache',
				'X-CSRFToken': this.getCookie('csrftoken'),
			},
			credentials: 'same-origin',
			body: JSON.stringify(params),
		};
		fetch(this.apiBase + url, payload)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (typeof callback === 'function') {
					callback(data, url);
				}
			});
	}
	doAjaxDelete(url, id, callback) {
		const payload = {
			method: 'DELETE',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				Cache: 'no-cache',
				'X-CSRFToken': this.getCookie('csrftoken'),
			},
			credentials: 'same-origin',
		};
		fetch(this.apiBase + url + id, payload)
			.then((response) => {
				if (response.status !== 204 && response.status !== 404 && response.status !== 200) {
					console.error(`Looks like there was a problem. Status Code: ${response.status}`);
				}
				response.text().then((data) => {
					let deleteJson = {};
					if (typeof callback === 'function') {
						if (typeof(data) === 'string' && data !== '') {
							deleteJson = JSON.parse(data);
							deleteJson.initialId = id;
						} else {
							deleteJson.initialId = id;
						}
						callback(deleteJson);
					}
				});
				return null;
			});
	}
	getCheckedItems(elementClass) {
		const checkboxes = Array.from(document.querySelectorAll(elementClass));
		const checkedItems = [];
		checkboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				// If there are additional filters defined in the dataset add them to the filter
				if ('groupedCategories' in checkbox.parentElement.dataset) {
					checkbox.parentElement.dataset.groupedCategories.split(',').forEach((value) => {
						checkedItems.push(value);
					})
				}
				checkedItems.push(checkbox.value);
			}
		});
		return checkedItems;
	}
	getCheckedTeachers(elementClass) {
		const checkboxes = Array.from(document.querySelectorAll(elementClass));
		const checkedItems = [];
		checkboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				checkedItems.push(checkbox.getAttribute('data-value'));
			}
		});
		return checkedItems;
	}
	filtersInitialized() {
	  this.filterInitialized = true;

	  if (this.filtersInitializedCallback !== undefined) {
	  	this.filtersInitializedCallback();
		}
	}
	getSearchValue() {
		let input;
		if (document.querySelector('.shop-search-input-js')) {
			input = document.querySelector('.shop-search-input-js');
		} else if (document.querySelector('.general-search-input-js')) {
			input = document.querySelector('.general-search-input-js');
		}
		return input.value;
	}
	convertOldCategoryValues(categoryFilters) {
		// On 18-8-2020 the category filters switched to API names, make sure the old values are still supported.
		const oldFilters = {
			'Collegereeks': 'Collegereeks',
			'Excursies Collegereeks': 'Excursies_Collegereeks',
			'Excursies': 'Excursies_Collegereeks',
			'Lezingen': 'Lezing',
			'Lezingen Live': 'Live_College',
			'Collegereeks Live': 'Live_Collegereeks',
			'Reizen': 'Reis',
			'Rondleidingen': 'Rondleiding',
			'Studiedagen': 'Studiedag',
			'Wandelingen': 'Wandeling',
			'Workshops': 'Workshop',
		};
		Object.keys(oldFilters).forEach((key) => {
			const index = categoryFilters.indexOf(key);
			if (index > -1) {
				categoryFilters.splice(index, 1);
				categoryFilters.push(oldFilters[key]);
			}
		});
		const supportedFilters = [
			'Collegereeks',
			'Excursies_Collegereeks',
			'Lezing',
			'Live_College',
			'Live_Collegereeks',
			'Reis',
			'Rondleiding',
			'Studiedag',
			'Wandeling',
			'Workshop',
			'Lezingen_Thuis',
			'Thuis_College'
		];
		const filters = [];
		categoryFilters.forEach((filter, index) => {
			if (supportedFilters.includes(filter)) {
				filters.push(filter);
			}
		});
		return filters;
	}
	buildFilterObject() {
		let filters = {};

		if (this.getSearchValue() !== '') {
			filters.search = this.getSearchValue();
		}
		if (this.filterInitialized) {
			if (document.querySelector('.selected-dates-js') && document.querySelector('.selected-dates-js').value !== '') {
				filters.selected_dates = document.querySelector('.selected-dates-js').value.replace(/; /g, ',');
			}
			filters.product_subject = this.getCheckedItems('.subject-checkbox-js');
			filters.product_category = this.getCheckedItems('.category-checkbox-js');
			filters.city = this.getCheckedItems('.city-checkbox-js');
			filters.teacher = this.getCheckedTeachers('.teacher-checkbox-js');
			filters.month = this.getCheckedItems('.period-checkbox-js');
			filters.day = this.getCheckedItems('.day-checkbox-js');
			filters.time_period = this.getCheckedItems('.daypart-checkbox-js');
			filters.unit_price = this.getCheckedItems('.unit-price-checkbox-js');
			filters.location = this.getCheckedItems('.location-checkbox-js');
		} else {
			const categoryList = document.querySelector('.filter-categories-js');
			const subjectList = document.querySelector('.filter-subjects-js');
			if (this.urlParams.subject !== undefined) {
				filters.product_subject = decodeURIComponent(this.urlParams.subject).split(',');
			} else if (subjectList !== null && subjectList.dataset.highlightedSubject !== undefined) {
				filters.product_subject = [subjectList.dataset.highlightedSubject];
			}
			if ('online' in this.urlParams) {
				filters.online_available = decodeURIComponent(this.urlParams.online) === 'true';
			}
			// We convert the category filters to make sure we retrieve
			// the correct API names as this has been changed 18-08-2020
			if (this.urlParams.category !== undefined) {
				filters.product_category = decodeURIComponent(this.urlParams.category).split(',');
				filters.product_category = this.convertOldCategoryValues(filters.product_category);
			} else if (categoryList !== null && categoryList.dataset.highlightedCategory !== undefined) {
				filters.product_category = [categoryList.dataset.highlightedCategory];
			}

			if (this.urlParams.city !== undefined) {
				filters.city = decodeURIComponent(this.urlParams.city).split(',');
			}
			if (this.urlParams.teacher !== undefined) {
			    // The teacher filter will only work on sfid of the teacher
				if (this.filterInitialized) {
					filters.teacher = decodeURIComponent(this.urlParams.teacher).split(',');
				}
			}
			if (this.urlParams.month !== undefined) {
				filters.month = decodeURIComponent(this.urlParams.month).split(',');
			}
			if (this.urlParams.day !== undefined) {
				filters.day = decodeURIComponent(this.urlParams.day).split(',');
			}
			if (this.urlParams.time !== undefined) {
				filters.time_period = decodeURIComponent(this.urlParams.time).split(',');
			}
			if (this.urlParams.dates !== undefined) {
				filters.selected_dates = decodeURIComponent(this.urlParams.dates).split(',');
			}
			if (this.urlParams.search !== undefined) {
				filters.search = decodeURIComponent(this.urlParams.search).split(',');
				if (document.querySelector('.shop-search-input-js')){
					document.querySelector('.shop-search-input-js').value = this.urlParams.search;
				}
			}
			if (this.urlParams.location !== undefined) {
				// filters.location = decodeURIComponent(this.urlParams.location).split(',');
				if (document.querySelector('.location-checkbox-js')){
					filters.location = document.querySelector('.location-checkbox-js').value;
				}
			}

			// We only unload from cache once and if there are no urlParams
			if (lscache.get('cache-filters') && Object.keys(this.urlParams).length === 0) {
				filters = lscache.get('cache-filters');
			}
		}

		// We cache the current configuration in the cache if it contains keys
		if (Object.keys(filters).length > 0) {
			lscache.set('cache-filters', filters, 5); // Store it in localstorage for 5 minutes
		}

		// Limit and offset are included in the filters but should not be stored in the cache
		filters.limit = this.limit;
		if (this.type.indexOf('product') > -1) {
			// Always use double the actual limit for combined products
			filters.offset = this.offset;
		} else {
			filters.offset = this.limit * this.page;
		}

		return filters;
	}
	signUpNewsletter(email, callback) {
		const url = 'newsletter/';
		const params = {
			email,
		};
		this.doAjaxPost(url, params, callback);
	}
	fetchShoppingCart(callback) {
		const url = 'cart/';
		this.doAjaxGet(url, {}, callback);
	}
	fetchShoppingCartCount(callback) {
		const url = 'cart/amount/';
		this.doAjaxGet(url, {}, callback);
	}
	fetchFilters(callback) {
		const url = `filters/?type=${this.type[0]}`;
		this.doAjaxGet(url, {}, callback);
	}
	fetchFavorites(callback) {
		const url = 'favorite/';
		this.doAjaxGet(url, {}, callback);
	}
	fetchAddress(callback, filters) {
		const url = 'address/';
		this.doAjaxGet(url, filters, callback);
	}
	fetchItems(callback, reset) {
		const filters = reset ? {} : this.buildFilterObject();
		this.type.forEach((type) => {
			const url = `${type}s/`;
			this.doAjaxGet(url, filters, callback);
		});
	}
	fetchReservation(params) {
		const url = 'reservations/';
		this.doAjaxGet(url, params);
	}
	fetchBookDeliveryTime(bookId, callback) {
		const url = `books/${bookId}`;
		this.doAjaxGet(url, {}, callback);
	}
	addFavoriteProduct(sfid, productType, callback) {
		const params = {};
		params[productType] = sfid;
		const url = 'favorite/';
		this.doAjaxPost(url, params, callback);
	}
	deleteFavoriteProduct(favoriteId, callback) {
		const url = 'favorite/';
		this.doAjaxDelete(url, favoriteId, callback);
	}
	appendProductToCart(params, callback) {
		const url = 'cart/';
		this.doAjaxPost(url, params, callback);
	}
	appendStudyMaterialToCart(params, callback) {
		const url = 'cart/relatedproduct/';
		this.doAjaxPost(url, params, callback);
	}
	addDiscountCode(params, callback) {
		const url = 'cart/discountcode/';
		this.doAjaxPost(url, params, callback);
	}
	removeDiscountCode(discountCode, callback) {
		const url = 'cart/discountcode/';
		this.doAjaxDelete(url, discountCode, callback);
	}
	removeGiftCard(id, callback) {
		const url = 'cart/giftcard/';
		this.doAjaxDelete(url, id, callback);
	}
	addVoucher(params, callback) {
		const url = 'cart/voucher/';
		this.doAjaxPost(url, params, callback);
	}
	removeVoucher(id, callback) {
		const url = 'cart/voucher/';
		this.doAjaxDelete(url, id, callback);
	}
	lazyLoadItems(changes) {
		changes.forEach((change) => {
			if (change.isIntersecting) {
				reservationsApi.page += 1;
				reservationsApi.fetchItems(renderItems, false);
			}
		});
	}
	checkEmailAvailability(email, callback) {
		const url = 'email/';
		const params = {
			email,
		};
		this.doAjaxPost(url, params, callback);
	}

	setOptOut(productId, optOut, callback) {
		this.doAjaxPost(
			'cart/optout/',
			{
				opt_out: optOut,
				id: productId,
			},
			callback
		)
	}
}

const reservationsApi = new API();

const convertRank = (rank, pagenumber) => {
	const rankPrefix = pagenumber + 1;
	const convertedRank = (rank !== null && rank !== undefined) ? String(rank.toFixed(3)).replace('.', '') : 0;
	const prefixedRank = `${rankPrefix}${convertedRank}`;
	return prefixedRank;
};

const renderBooks = (data) => {
	const bookList = document.querySelector('.book-list-js');
	if (reservationsApi.page === 0 && document.querySelector('.search-list-js') === null) {
		bookList.innerHTML = '';
	}
	const template = Handlebars.compile(document.querySelector('#tpl-book').innerHTML);
	data.results.forEach((result) => {
		const book = result;
		book.order = convertRank(book.rank, reservationsApi.page);
		const rendered = template(book);
		bookList.innerHTML += rendered;
	});
};

const renderFavorites = (data) => {
	let favoriteIdsCss = '';
	data.results.forEach((result) => {
		favoriteIdsCss += `.p-${result.product} .course-title:after,`;
		favoriteIdsCss += `.p-${result.product_group} .course-title:after,`;
	});
	favoriteIdsCss = favoriteIdsCss.slice(0, -1);

	const css = `${favoriteIdsCss} { content: ""; }`;
	const head = document.head || document.getElementsByTagName('head')[0];
	const style = document.createElement('style');

	style.type = 'text/css';
	if (style.styleSheet) {
		style.styleSheet.insertRule(css);
	} else {
		style.appendChild(document.createTextNode(css));
	}

	head.appendChild(style);
};


const hexToRgb = (hex) =>{
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : {r:255, g:255, b:255,
  };
};

function setForegroundColor(hex) {
	const rgb = hexToRgb(hex);
	var sum = Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) / 1000);
	return (sum > 128) ? '000000' : 'FFFFFF';
}

const addProductButtons = (product) => {
  const waitingListUrl = document.querySelector('.waiting-list-url-js');

  if (product.product_group.cta_label) {
		product.squareButtonText = product.btnText = product.product_group.cta_label;
		product.customStyleClass = 'custom-color-button';
		if (product.product_group.cta_color) {
			product.customCss = {
				color: product.product_group.cta_color,
				colorHover: product.product_group.cta_color_hover,
				textColor: setForegroundColor(product.product_group.cta_color),
				textColorHover: setForegroundColor(product.product_group.cta_color_hover),
			};
			product.customCssTarget = `data-customcolor="customcolor-id-${product.id}"`;
			product.squareButtonClass = '--custom-colour';
			product.btnClass = 'btn--action';
		}
	} else {
		if (product.show_as_full) {
			product.squareButtonText = product.btnText = 'Volgeboekt';
			product.squareButtonClass = product.btnClass = 'btn--waiting-list';
		} else if (product.is_new) {
			product.btnText = product.squareButtonText = 'Nieuw';
			product.btnClass = product.squareButtonClass = '--yellow';
		} else if (product.discount !== null && product.discount !== undefined && product.discount.percentage !== 0) {
			product.squareButtonText = product.discount.percentage + 'Korting';
			product.squareButtonClass = '--yellow';
		} else {
			// Product groups
			product.squareButtonText = 'Bekijk meer';
			product.squareButtonClass = '';
			// Products
			product.btnClass = 'btn--action';
			product.btnText = 'Inschrijven';
		}

		if (product.product_group.highlighted_label !== undefined && product.product_group.highlighted_label !== null) {
			product.squareButtonClass = `btn--action --${product.product_group.highlighted_label_colour}`;
			product.squareButtonText = product.product_group.highlighted_label;
		}
	}

	// These settings overwrite the previous values, it has to do with the quantity
  if (reservationsApi.type[0] === 'reservation') {
		if(product.almost_full) {
			product.btnClass = 'btn--almost-full';
			product.btnText = 'Bijna vol!';

			product.customCssTarget = '';
			product.customCss = '';
			product.squareButtonClass = '';
		}
		if(product.is_full) {
			product.htmlOnclick = '';
			if (waitingListUrl) {
				product.htmlUrl = waitingListUrl.value.replace('--abcdef--', product.id);
			}
			product.btnClass = 'btn--waiting-list';
			product.btnText = product.is_journey ? 'Volgeboekt' : 'Wachtlijst';

			product.customCssTarget = null;
			product.customCss = null;
		}
	}
};

const addVideoButtons = (product) => {
	if (product.cta_label) {
		product.squareButtonText = product.btnText = product.cta_label;
		product.customStyleClass = 'custom-color-button';
		if (product.cta_color) {
			product.customCss = {
				color: product.cta_color,
				colorHover: product.cta_color_hover,
				textColor: setForegroundColor(product.cta_color),
				textColorHover: setForegroundColor(product.cta_color_hover),
			};
			product.customCssTarget = `data-customcolor="customcolor-id-${product.id}"`;
			product.squareButtonClass = '--custom-colour';
			product.btnClass = 'btn--action';
		}
	}
	else{
		if (product.is_new) {
			product.btnText = product.squareButtonText = 'Nieuw';
			product.btnClass = product.squareButtonClass = '--yellow';
		} else if (product.discount !== null && product.discount !== undefined && product.discount.percentage !== 0) {
			product.squareButtonText = product.discount.percentage + 'Korting';
			product.squareButtonClass = '--yellow';
		} else {
			// Product groups
			product.squareButtonText = 'BEKIJK MEER';
			product.squareButtonClass = '';
		}
	}
};

const renderProducts = (data) => {
	const productList = document.querySelector('.course-list-js');
	const template = Handlebars.compile(document.querySelector('#tpl-product').innerHTML);
	if (reservationsApi.page === 0 && document.querySelector('.search-list-js') === null) {
		productList.innerHTML = '';
	}

	data.results.forEach((result) => {
		const product = result;
		const availableFrom = moment(product.first_available_date);
		const startDate = moment(product.start);
		const endDate = moment(product.end);

		product.htmlDate = startDate.format('D MMM').replace('.', '');
		product.htmlDay = startDate.format('dddd');

		product.htmlStartTime = startDate.format('HH:mm');
		product.htmlEndTime = endDate.format('HH:mm');

		product.htmlFromDate = availableFrom.format('D MMM');
		product.htmlUrl = '#';
		product.htmlOnclick = `onShoppingCartChange(event, 'products', '${product.id}', 1)`;
		addProductButtons(product);

		product.displayPrice = product.display_price;
		product.price = parseFloat(product.unitprice, 10).toFixed(2);
		product.order = convertRank(product.rank, reservationsApi.page);

		const rendered = template(product);
		productList.innerHTML += rendered;
	});
};

const renderVideos = (data) => {
	const productList = document.querySelector('.video-course-list-js');
	const template = Handlebars.compile(document.querySelector('#tpl-video').innerHTML);
	if (reservationsApi.page === 0 && document.querySelector('.search-list-js') === null) {
		productList.innerHTML = '';
	}

	data.results.forEach((result) => {
		const product = result;

		product.htmlOnclick = `onShoppingCartChange(event, 'products', '${product.id}', 1)`;
		addVideoButtons(product);
		product.primary_image = result.primary_image;
		product.price = parseFloat(product.unitprice, 10).toFixed(2);
		product.order = convertRank(product.rank, reservationsApi.page);

		const rendered = template(product);
		productList.innerHTML += rendered;
	});
};

const renderItems = (data) => {
	if (document.querySelector('.filter-result-count-js')) {
		const resultCount = document.querySelector('.filter-result-count-js');
		resultCount.innerHTML = data.count;
	}

	if (data.type === 'book') {
		renderBooks(data);
	} else if (data.type === 'product_group' || data.type === 'products') {
		renderProducts(data);
	} else if (data.type === 'video') {
		renderVideos(data);
	}

	if (data.type === 'product_group') {
		reservationsApi.offset = data.offset;
	}

	const itemLength = document.querySelectorAll('.course-item').length + document.querySelectorAll('.video-item').length;
	if (reservationsApi.observationTarget !== null && (data.count > itemLength && data.results.length > 0)) {
		reservationsApi.observer.observe(reservationsApi.observationTarget);
		reservationsApi.observationTarget.classList.remove('hidden');
	} else if (reservationsApi.observationTarget !== null) {
		reservationsApi.observer.unobserve(reservationsApi.observationTarget);
		reservationsApi.observationTarget.classList.add('hidden');
	}
};
const renderFilterCategories = (categories, onlineCategories, groupedCategories, onDemandCategories) => {
	const urlParams = reservationsApi.urlParams;
	const categoryList = document.querySelector('.filter-categories-js');
	const urlCategories = categoryList.dataset.highlightedCategory ? categoryList.dataset.highlightedCategory : urlParams.category ? reservationsApi.convertOldCategoryValues(urlParams.category.split(',')) : '';
	categoryList.innerHTML = '';
	const activePage = document.querySelector('.object-types-js').getAttribute('data-type');

	if (activePage === 'products') {
		delete categories.Journeys;
		delete categories.Colleges;
	}

	delete categories.Books;

	const template = Handlebars.compile(document.querySelector('#tpl-filter-option').innerHTML);
	Object.keys(categories).forEach((key) => {
		let checkedStatus;
		if (!reservationsApi.filterInitialized &&
				(urlCategories.indexOf(key) !== -1 ||
					'online' in urlParams && key in onlineCategories ||
				 (lscache.get('cache-filters') !== null && lscache.get('cache-filters').product_category !== undefined && lscache.get('cache-filters').product_category.indexOf(key) !== -1))) {
			checkedStatus = 'checked';
		} else {
			checkedStatus = '';
		}
		let options = {
			checkedStatus, key, category: 'category', value: categories[key]
		};
		if (key in groupedCategories) {
      options['grouped_categories'] = groupedCategories[key].join(',');
		}
		if (key in onlineCategories) {
		 	options['online_product'] = true;
		}
		if (key in onDemandCategories) {
			options['on_demand_product'] = true;
		}
		const rendered = template(options);
		categoryList.innerHTML += (rendered);
	});
};
const renderFilterSubjects = (subjects) => {
	const urlParams = reservationsApi.urlParams;
	const subjectList = document.querySelector('.filter-subjects-js');
	const urlSubjects = subjectList.dataset.highlightedSubject ? subjectList.dataset.highlightedSubject : (urlParams.subject ? urlParams.subject : '');
	subjectList.innerHTML = '';

	const template = Handlebars.compile(document.querySelector('#tpl-filter-option').innerHTML);
	Object.keys(subjects).forEach((key) => {
		let checkedStatus;
		if (!reservationsApi.filterInitialized &&
				(urlSubjects.indexOf(key) !== -1 ||
			   (lscache.get('cache-filters') !== null && lscache.get('cache-filters').product_subject !== undefined && lscache.get('cache-filters').product_subject.indexOf(key) !== -1))) {
			checkedStatus = 'checked';
		} else {
			checkedStatus = '';
		}
		const rendered = template({
			checkedStatus, key, category: 'subject', value: subjects[key]
		});
		subjectList.innerHTML += (rendered);
	});
};
const renderFilterTeachers = (teachers) => {
	const urlParams = reservationsApi.urlParams;

	const teacherList = document.querySelector('.filter-teachers-js');
	const chosenTeacherFilters = document.querySelector('.chosen-teacher-filters-js');
	const urlTeachers = urlParams.teacher ? decodeURIComponent(urlParams.teacher).split(',') : '';

	teacherList.innerHTML = '';
	teachers.forEach((teacher) => {
		const listItem = document.createElement('li');
		let checkedStatus = '';
		// Validate if we need to check something based on the query parameters or the cache
		if (!reservationsApi.filterInitialized &&
			  (urlTeachers.indexOf(teacher.name) !== -1 ||
				 (lscache.get('cache-filters') !== null && lscache.get('cache-filters').teacher !== undefined && lscache.get('cache-filters').teacher.indexOf(teacher.sfid) !== -1))) {
			checkedStatus = 'checked';
			const newLabel = `<label class="chosen-filter" for="teacher-${teacher.sfid}">${teacher.name}</label>`;
			chosenTeacherFilters.insertAdjacentHTML('beforeEnd', newLabel);
		}
		listItem.innerHTML = `
		<input class="filter-checkbox teacher-checkbox-js" type="checkbox" id="teacher-${teacher.sfid}" ${checkedStatus} data-name="${teacher.name}" data-value="${teacher.sfid}" value="${teacher.name}" onchange="toggleTeacherFilter(this); onFilterChange();">
		<label class="filter-checkbox-label" for="teacher-${teacher.sfid}">${teacher.name}</label>`;
		teacherList.appendChild(listItem);
	});
};
const renderFilterCities = (cities) => {
	const urlParams = reservationsApi.urlParams;

	const cityList = document.querySelector('.filter-cities-js');
	const chosenCityFilters = document.querySelector('.chosen-city-filters-js');
	const urlCities = urlParams.city ? decodeURIComponent(urlParams.city).split(',') : '';

	cityList.innerHTML = '';
	cities.forEach((city) => {
		let checkedStatus;

		// Validate if we need to check something based on the query parameters or the cache
		if (!reservationsApi.filterInitialized &&
				(urlCities.indexOf(city.city) !== -1 ||
				 (lscache.get('cache-filters') !== null && lscache.get('cache-filters').city !== undefined && lscache.get('cache-filters').city.indexOf(city.city) !== -1))) {
			checkedStatus = 'checked';
			const newLabel = `<label class="chosen-filter" for="city-${city.sfid}">${city.city}</label>`;
			chosenCityFilters.insertAdjacentHTML('beforeEnd', newLabel);
		} else {
			checkedStatus = '';
		}
		const listItem = document.createElement('li');
		listItem.innerHTML = `
		<input ${checkedStatus} class="filter-checkbox city-checkbox-js" type="checkbox" id="city-${city.sfid}" value="${city.city}" onchange="toggleCityFilter(this); onFilterChange();">
		<label class="filter-checkbox-label" for="city-${city.sfid}">${city.city}</label>`;
		cityList.appendChild(listItem);
	});
};

const onFilterChange = () => {
	reservationsApi.page = 0;
	reservationsApi.offset = 0;
	reservationsApi.fetchItems(renderItems, false);
};

const onOnlineToggleChange = (element) => {
	// We toggle the filters meant for online products
	let onlineFilters = document.querySelectorAll('.online-only-filter input');
	if (element.checked) {
		onlineFilters.forEach((element) => element.checked = true);
	} else {
		onlineFilters.forEach((element) => element.checked = false);
	}
	onFilterChange();
};

const onVAthuisToggleChange = (element) => {
	// We toggle the filters meant for vathuis products
	let ondemandFilters = document.querySelectorAll('.on-demand-filter input');
	if (element.checked) {
		ondemandFilters.forEach((element) => element.checked = true);
	} else {
		ondemandFilters.forEach((element) => element.checked = false);
	}
	onFilterChange();
};

const onFilterChangeUnique = (element, e) => {
	e.preventDefault();

	let new_checked = element.checked;
	let list = document.getElementsByClassName(element.className);
	for(let item of list){
		item.checked = false;
	}
	element.checked = new_checked;

	reservationsApi.page = 0;
	reservationsApi.offset = 0;
	reservationsApi.fetchItems(renderItems, false);
};

const renderFilters = (filters) => {
  // We extract the online categories
	if (filters.categories !== undefined && document.querySelector('.filter-categories-js') !== null) {
		renderFilterCategories(filters.categories, filters.online_categories, filters.grouped_categories, filters.on_demand_categories);
	}
	if (filters.subjects !== undefined && document.querySelector('.filter-subjects-js') !== null) {
		renderFilterSubjects(filters.subjects);
	}
	if (filters.teachers.length > 0 && document.querySelector('.filter-teachers-js') !== null) {
		renderFilterTeachers(filters.teachers);
	}
	if (filters.locations.length > 0 && document.querySelector('.filter-cities-js') !== null) {
		renderFilterCities(filters.locations);
	}
	const urlParams = reservationsApi.urlParams;
	if (document.querySelector('.filter-datepicker-js')) {
		let flatPickrOptions = {
			inline: true,
			mode: 'multiple',
			enable: filters.dates,
			locale: 'nl',
			onChange: (selectedDates, dateStr) => {
				document.querySelector('.selected-dates-js').setAttribute('value', dateStr);
				onFilterChange();
			}
		};
		if (urlParams.dates) {
			document.querySelector('.selected-dates-js').value = decodeURIComponent(urlParams.dates).replace(/, /g, ';');
			flatPickrOptions['defaultDate'] = decodeURIComponent(urlParams.dates).split(',');
		} else if (lscache.get('cache-filters') !== null && lscache.get('cache-filters').selected_dates !== undefined) {
			document.querySelector('.selected-dates-js').value = lscache.get('cache-filters').selected_dates.replace(/, /g, ';');
			flatPickrOptions['defaultDate'] = lscache.get('cache-filters').selected_dates.split(',');
		}
		flatpickr('.filter-datepicker-js', flatPickrOptions);
	}
	if (urlParams.online && document.querySelector('.online-available-checkbox-js')) {
		document.querySelector('.online-available-checkbox-js').checked = true;
	}
	if (urlParams.location && document.querySelector('.location-checkbox-js')) {
		document.querySelector('.location-checkbox-js').checked = true;
	}
	reservationsApi.filtersInitialized();
};
const onShoppingCartChange = (e, type, productId, productAmount) => {
	e.preventDefault();
	const product = {
		category: type,
		id: productId,
		amount: productAmount,
	};
	reservationsApi.appendProductToCart(product, renderPaymentStep);
};

const removeGiftCardFromCart = (e, giftCardId) => {
	e.preventDefault();
	reservationsApi.removeGiftCard(giftCardId, renderPaymentStep);
};

const onStudyMaterialChange = (e, id, productId, amount=1) => {
	const productRow = document.querySelector(`tr[data-product-id="${id}"]`);
	// const amountt = productRow.querySelector('.related-product-amount-js');

	let product = new Object();
	if (productRow.querySelector('.related-product-checkbox-js').checked) {
		product = { id: id, amount: amount, product_id: productId };
	} else {
		product = { id: id, amount: amount, product_id: productId };
	}
	reservationsApi.appendStudyMaterialToCart(product, renderPaymentStep);
};

const onOptOutChange = (e, id) => {
	reservationsApi.setOptOut(id, e.target.checked);
};

document.addEventListener('DOMContentLoaded', () => {
	const itemPage = (
		(document.querySelector('.course-list-js') !== null ||
		document.querySelector('.book-list-js') !== null ||
		document.querySelector('.video-course-list-js') !== null) &&
		document.querySelector('.search-list-js') === null);
	if (itemPage) {
		reservationsApi.filtersInitializedCallback = () => {
			reservationsApi.fetchItems(renderItems, false);
		}
	}

	if (document.querySelector('.sidebar-filter-js')) {
		reservationsApi.fetchFilters(renderFilters);
	} else {
		if (itemPage) {
			reservationsApi.fetchItems(renderItems, false);
		}
	}
	if (document.querySelector('.logged-in-js')) {
		reservationsApi.fetchFavorites(renderFavorites);
	}

	const forms = Array.from(document.getElementsByTagName('form'));

	forms.forEach((form) => {
		Validation.init(form);
		Validation.lang = {
			required: 'Dit veld is verplicht!',
			email: '{label} is geen valide emailadres!',
			tel: '{label} is geen valide telefoonnummer!',
		};
	});
});
